<!-- <span class="fa-stack"
    placement="top"
    ngbTooltip="{{textTooltip}}"
    container="body">
    <i class="fas fa-circle fa-stack-2x" [ngClass]="itemColor"></i>
    <i class="fas fa-power-off fa-stack-1x fa-inverse"></i>
</span> -->
<span class="badge badge-pill"
    [ngClass]="itemColor"
    placement="top"
    ngbTooltip="{{textTooltip}}"
    container="body">
    <i class="fas fa-power-off"></i>
</span>